import { gql } from '@apollo/client';
import { ParagraphActivityPoiTeaserListFragment } from '../../Paragraph/ActivityPoiTeaserList/fragment';
import { ParagraphHotelOffersFragment } from '../../Paragraph/HotelOffers/fragment';
import { ParagraphHeroFragment } from '../../Paragraph/Hero/fragment';
import { ParagraphActivitySliderFragment } from '../../Paragraph/ActivitySlider/fragment';
import { ParagraphActivityListFragment } from '../../Paragraph/ActivityList/fragment';
import { ParagraphMerchantListFragment } from '../../Paragraph/MerchantList/fragment';
import { ParagraphActivityTabsFragment } from '../../Paragraph/ActivityTabs/fragment';
import { ParagraphRegionTeaserListFragment } from '../../Paragraph/RegionTeaserList/fragment';
import { ParagraphTextFragment } from '../../Paragraph/Text/fragment';
import { ParagraphFormularFragment } from '../../Paragraph/Formular/fragment';
import { ParagraphHeaderFragment } from '../../Paragraph/Header/fragment';
import { ParagraphSearchbarFragment } from '../../Paragraph/Searchbar/fragment';
import { ParagraphContainerFragment } from '../../Paragraph/Container/fragment';
import { ParagraphColumnsFragment } from '../../Paragraph/Columns/fragment';
import { ParagraphColumnFragment } from '../../Paragraph/Column/fragment';
import { ParagraphImageTextTeaserFragment } from '../../Paragraph/ImageTextTeaser/fragment';
import { ParagraphHotelListFragment } from '../../Paragraph/HotelList/fragment';
import { ParagraphTestimonialFragment } from '../../Paragraph/Testimonial/fragment';
import { ParagraphSearchResultsFragment } from '../../Paragraph/SearchResults/fragment';
import { ParagraphImageFragment } from '../../Paragraph/Image/fragment';
import { ParagraphImageAndTextFragment } from '../../Paragraph/ImageAndText/fragment';
import { ParagraphNewsListFragment } from '../../Paragraph/NewsList/fragment';
import { ParagraphProductListFragment } from '../../Paragraph/ProductList/fragment';
import { ParagraphEyeCatcherFragment } from '../../Paragraph/EyeCatcher/fragment';
import { ParagraphLinksFragment } from '../../Paragraph/Links/fragment';
import { ParagraphFromLibraryFragment } from '../../Paragraph/FromLibrary/fragment';
import { ParagraphCustomTeaserListFragment } from '../../Paragraph/CustomTeaserList/fragment';
import { ParagraphPassTableFragment } from '../../Paragraph/PassTable/fragment';
import { ParagraphPassMapFragment } from '../../Paragraph/PassMap/fragment';
import { ParagraphPassListMapFragment } from '../../Paragraph/PassListMap/fragment';
import { ParagraphSearchByIdFragment } from '../../Paragraph/SearchById/fragment';
import { PersonFragment, PersonTeaserFragment } from '../Person/fragment';
import { PartnerFragment } from '../../../graphql/fragments/Partner';
import { ParagraphAuthorsFragment } from '../../Paragraph/Authors/fragment';
import { ParagraphPartnerFragment } from '../../Paragraph/Partner/fragment';
import { ParagraphInfoBoxFragment } from '../../Paragraph/InfoBox/fragment';
import { ParagraphCommentBoxFragment } from '../../Paragraph/CommentBox/fragment';
import { ParagraphAdSlotFragment } from '../../Paragraph/AdSlot/fragment';
import { ParagraphFaqFragment } from '../../Paragraph/Faq/fragment';

export const PageFragment = gql`
  fragment PageFragment on Page {
    id
    title
    updatedAt
    url(frontend: $frontend)
    frontend {
      name
    }
    category {
      ...TermCategoryFragment
    }
    showTitle
    metatags(frontend: $frontend) {
      ...MetaTagsFragment
    }
    isGroupSearch
    authors {
      ...PersonTeaserFragment
    }
    partner {
      ...PartnerFragment
    }
    content {
      ... on ParagraphInterface {
        id
      }
      __typename
      ...ParagraphHeaderFragment
      ...ParagraphActivityListFragment
      ...ParagraphHotelListFragment
      ...ParagraphMerchantListFragment
      ...ParagraphActivityTabsFragment
      ...ParagraphActivityPoiTeaserListFragment
      ...ParagraphHeroFragment
      ...ParagraphHotelOffersFragment
      ...ParagraphActivitySliderFragment
      ...ParagraphTextFragment
      ...ParagraphFormularFragment
      ...ParagraphRegionTeaserListFragment
      ...ParagraphSearchbarFragment
      ...ParagraphContainerFragment
      ...ParagraphColumnsFragment
      ...ParagraphTestimonialFragment
      ...ParagraphSearchResultsFragment
      ...ParagraphImageFragment
      ...ParagraphImageAndTextFragment
      ...ParagraphNewsListFragment
      ...ParagraphProductListFragment
      ...ParagraphEyeCatcherFragment
      ...ParagraphLinksFragment
      ...ParagraphFromLibrary
      ...ParagraphCustomTeaserList
      ...ParagraphPassTable
      ...ParagraphPassMap
      ...ParagraphPassListMap
      ...ParagraphSearchById
      ...ParagraphPartner
      ...ParagraphAuthors
      ...ParagraphInfoBox
      ...ParagraphCommentBox
      ...ParagraphAdSlot
      ...ParagraphFaq
    }
  }

  ${ParagraphFaqFragment}
  ${ParagraphAdSlotFragment}
  ${ParagraphInfoBoxFragment}
  ${ParagraphCommentBoxFragment}
  ${PartnerFragment}
  ${PersonTeaserFragment}
  ${ParagraphSearchByIdFragment}
  ${ParagraphActivityPoiTeaserListFragment}
  ${ParagraphTextFragment}
  ${ParagraphHeaderFragment}
  ${ParagraphHeroFragment}
  ${ParagraphFormularFragment}
  ${ParagraphHotelOffersFragment}
  ${ParagraphActivitySliderFragment}
  ${ParagraphActivityListFragment}
  ${ParagraphHotelListFragment}
  ${ParagraphMerchantListFragment}
  ${ParagraphActivityTabsFragment}
  ${ParagraphRegionTeaserListFragment}
  ${ParagraphSearchbarFragment}
  ${ParagraphContainerFragment}
  ${ParagraphColumnsFragment}
  ${ParagraphColumnFragment}
  ${ParagraphImageTextTeaserFragment}
  ${ParagraphTestimonialFragment}
  ${ParagraphSearchResultsFragment}
  ${ParagraphImageFragment}
  ${ParagraphImageAndTextFragment}
  ${ParagraphNewsListFragment}
  ${ParagraphProductListFragment}
  ${ParagraphEyeCatcherFragment}
  ${ParagraphLinksFragment}
  ${ParagraphFromLibraryFragment}
  ${ParagraphCustomTeaserListFragment}
  ${ParagraphPassTableFragment}
  ${ParagraphPassMapFragment}
  ${ParagraphPassListMapFragment}
  ${ParagraphAuthorsFragment}
  ${ParagraphPartnerFragment}
`;
